import { render, staticRenderFns } from "./AdminSpecialists.vue?vue&type=template&id=11f7ae42"
import script from "./AdminSpecialists.vue?vue&type=script&lang=js"
export * from "./AdminSpecialists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports